import React from 'react';
import './ErrorModal.css';

const ErrorModal = ({ message, onClose }) => {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>Error</h3>
                <p>{message}</p>
                <button onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

export default ErrorModal;
